import arenaData from './arenaData.json';

// Default arena loaded from PDF-extracted JSON.
// Each seat has its EXACT (x, y) position in viewBox coords (12.7×12.7 box).
// 40 sectors, 3036 seats automatically extracted.

export const ARENA_VIEWBOX = arenaData.viewBox;
export const ARENA_BG_IMAGE = arenaData.bgImage;
export const SEAT_SIZE = 12.7;

export const STAGE = {
  id: 'stage',
  label: 'SZÍNPAD',
  x: 950, y: 800, width: 480, height: 280,
};

// Sector list - each sector has: id, name, prefix, color, rows, maxSeatsPerRow,
// totalSeats, bbox (x,y,w,h), seats[] (each: {r, s, x, y}).
export const DEFAULT_SECTORS = arenaData.sectors;

export const DEFAULT_ARENA = {
  name: 'Kanizsa Aréna',
  stage: STAGE,
  sectors: DEFAULT_SECTORS,
  viewBox: ARENA_VIEWBOX,
  bgImage: ARENA_BG_IMAGE,
};
